"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetch = exports.axiosInstance = void 0;
var axios_1 = __importDefault(require("axios"));
// https://github.com/axios/axios#creating-an-instance
exports.axiosInstance = axios_1.default.create();
/*
* Example for simple usage:
*
import * as request from '@empiriecom/module-inspire-components/utils/useFetch';

request.useFetch({
  urlPrimary: 'http://urlPrimary',
}).then((data) => {
  // do something with data
});
* */
/*
* Example full possible options:
*
import * as request from '@empiriecom/module-inspire-components/utils/useFetch';

request.useFetch({
  urlPrimary: 'http://urlPrimary',
  urlSecondary: 'http://urlSecondary',
  urlPageNotFound: 'http://pageNotFound',
  fetchTimerPrimary: 1000,
  fetchTimerSecondary: 5000,
  fetchTimerPageNotFound: 5000,
}).then((data) => {
  // do something with data
});
* */
var useFetch = function (_a) {
    var urlPrimary = _a.urlPrimary, _b = _a.urlSecondary, urlSecondary = _b === void 0 ? undefined : _b, _c = _a.urlPageNotFound, urlPageNotFound = _c === void 0 ? undefined : _c, _d = _a.fetchTimerPrimary, fetchTimerPrimary = _d === void 0 ? 5000 : _d, _e = _a.fetchTimerSecondary, fetchTimerSecondary = _e === void 0 ? 5000 : _e, _f = _a.fetchTimerPageNotFound, fetchTimerPageNotFound = _f === void 0 ? 5000 : _f, _g = _a.throwErrorPrimary, throwErrorPrimary = _g === void 0 ? false : _g;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, errorPrimary_1, data, errorSecondary_1, data, errorPageNotFound_1, errorObject, errorObject, errorObject;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _h.trys.push([0, 2, , 15]);
                    return [4 /*yield*/, exports.axiosInstance.get(urlPrimary, {
                            responseType: 'json',
                            timeout: fetchTimerPrimary,
                        })];
                case 1:
                    data = (_h.sent()).data;
                    return [2 /*return*/, data];
                case 2:
                    errorPrimary_1 = _h.sent();
                    if (!urlSecondary) return [3 /*break*/, 13];
                    _h.label = 3;
                case 3:
                    _h.trys.push([3, 5, , 12]);
                    return [4 /*yield*/, exports.axiosInstance.get(urlSecondary, {
                            responseType: 'json',
                            timeout: fetchTimerSecondary,
                        })];
                case 4:
                    data = (_h.sent()).data;
                    return [2 /*return*/, data];
                case 5:
                    errorSecondary_1 = _h.sent();
                    if (!urlPageNotFound) return [3 /*break*/, 10];
                    _h.label = 6;
                case 6:
                    _h.trys.push([6, 8, , 9]);
                    return [4 /*yield*/, exports.axiosInstance.get(urlPageNotFound, {
                            responseType: 'json',
                            timeout: fetchTimerPageNotFound,
                        })];
                case 7:
                    data = (_h.sent()).data;
                    return [2 /*return*/, data];
                case 8:
                    errorPageNotFound_1 = _h.sent();
                    errorObject = JSON.parse(JSON.stringify(errorPageNotFound_1.message));
                    return [2 /*return*/, errorObject];
                case 9: return [3 /*break*/, 11];
                case 10:
                    errorObject = JSON.parse(JSON.stringify(errorSecondary_1.message));
                    return [2 /*return*/, errorObject];
                case 11: return [3 /*break*/, 12];
                case 12: return [3 /*break*/, 14];
                case 13:
                    if (throwErrorPrimary) {
                        throw new Error();
                    }
                    errorObject = JSON.parse(JSON.stringify(errorPrimary_1.message));
                    return [2 /*return*/, errorObject];
                case 14: return [3 /*break*/, 15];
                case 15: return [2 /*return*/];
            }
        });
    });
};
exports.useFetch = useFetch;
exports.default = exports.useFetch;
//# sourceMappingURL=useFetch.js.map